import React from 'react'

import { makeStyles, Box } from '@material-ui/core'
import { ReactComponent as NewIcon } from './new-icon.svg'
import { ReactComponent as PhoneIcon } from './phone-icon.svg'

const useStyles = makeStyles(theme => ({
  newBadgeContainer: {
    position: 'absolute',
    height: 15,
    right: -8,
    [theme.breakpoints.up('sm')]: {
      top: '20%',
      width: 30,
    },
    [theme.breakpoints.down('sm')]: {
      top: '10%',
      width: 20,
    },
  },
}))

const SidebarItemMobileApp = ({ style: { fontSize } }) => {
  const classes = useStyles()

  return (
    <Box
      minHeight={fontSize}
      minWidth={fontSize}
      overflow="visible"
      position="relative"
    >
      <PhoneIcon width={fontSize} height={fontSize} />
      <Box className={classes.newBadgeContainer}>
        <NewIcon width="100%" height="100%" />
      </Box>
    </Box>
  )
}

export default SidebarItemMobileApp
